/*
 * 文件EN: Details.vue,
 * 文件CN: 还款详情-拮据详情1,
 * 创建时间: Wednesday, 8th July 2020 11:11:11 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */
<template>
  <div class="y-list wrapper">
    <common-header />
    <div class="table-list-data" v-loading="loading">
      <div class="table-content">
        <el-table
          :data="tableData"
          header-cell-class-name="dark"
          :height="tableHeight"
          stripe
          border
        >
          <table-column type="index" label="序号"></table-column>
          <table-column prop="test" label="期号"></table-column>
          <table-column prop="test" label="借据时间"></table-column>
          <table-column prop="test" label="借据编号"></table-column>
          <table-column prop="test" label="商户名称"></table-column>
          <table-column prop="test" label="商户号"></table-column>
          <table-column prop="test" label="渠道"></table-column>
          <table-column prop="test" label="还款卡号"></table-column>
          <table-column prop="test" label="行别"></table-column>
          <table-column prop="test" label="借据本金"></table-column>
          <table-column prop="test" label="滞纳金"></table-column>
          <table-column prop="test" label="违约金"></table-column>
          <table-column prop="test" label="还款状态"></table-column>
          <table-column prop="test" label="还款时间"></table-column>
          <el-table-column width="80">
            <div slot="header" class="fixed-right-column">操作</div>
            <template slot-scope="{ row }">
              <el-button
                @click="handleCheck(row,'repaymentCheck/strainIndex/details')"
                type="text"
                size="small"
              >查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <common-page :page-data="pageData" @change="onChangePage"></common-page>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    id() {
      return this.$route.query._i
    },
  },
  data() {
    return {
      // loadin加载
      loading: false,
      // 分页数据
      pageData: { pageSize: 20, currentPage: 1, total: 0 },
      // 表格数据
      tableData: [{}],
    }
  },
  async mounted() {},
  methods: {
    /**
     * @desc 跳转
     * @param {行数据,跳转地址}
     */
    handleCheck(row, to) {
      this.$router.push({
        path: `${to}`,
        query: { _i: row.id },
      })
    },
    // 分页
    onChangePage(page) {
      this.pageData.currentPage = page
      this.initList()
    },
    // 请求列表接口
    async initList() {
      this.loading = true
      this.pageData.currentPage = 1
      const {
        pageData: { currentPage, pageSize },
        postData,
        $store: { dispatch },
      } = this
      await dispatch('T9/APILog/getList', {
        ...postData,
        currentPage,
        pageSize,
      })
        .then((res) => {
          this.loading = false
          let {
            invokeCount,
            invokeCost,
            list: { list, total, pageNum },
          } = res
          // 第一层计数
          this.invokeCount = invokeCount
          this.invokeCost = invokeCost
          // 第二层才有表格数据
          this.tableData = list
          this.pageData.currentPage = pageNum
          this.pageData.total = total
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/tableList.scss';
</style>
